import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/apps/payments-checkout/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["identifyCheckoutSession","setObservabilityContext"] */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/modules/shared/observability/src/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["reportDegradation"] */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/modules/shared/observability/src/reportDegradation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["isReported","reportError"] */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/modules/shared/observability/src/reportError.ts");
;
import(/* webpackMode: "eager", webpackExports: ["startSessionReplay"] */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/modules/shared/observability/src/sessionReplay.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/node_modules/@stone-payments/jade-design-tokens/stone/bundle.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/node_modules/@stone-payments/jade-design-tokens/stone/fonts.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/apps/payments-checkout/app/global.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/pxp-checkout-v3/pxp-checkout-v3/node_modules/next/dist/client/script.js");
